import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { loader, p } from "~/misc/common";
import QrScanner from "qr-scanner";
import { createConsumer } from "@rails/actioncable";
import moment from "moment";

export default class extends Controller {
  async connect() {
    p('initQrGroupReportApp');

    const el = this.element as HTMLDivElement;

    const video = document.getElementById("preview") as HTMLVideoElement;

    let mirrored = false;
    function refreshMirror() {
      mirrored ? $('#flip').addClass('active') : $('#flip').removeClass('active');
      video.style.transform = mirrored ? 'scaleX(-1)' : '';
    }
    $('#flip').on('click', function () {
      $('#flip').blur();
      mirrored = !mirrored;
      refreshMirror();
    });
    refreshMirror();

    const scanner = new QrScanner(
      video,
      onScan,
      {
        highlightScanRegion: true,
        highlightCodeOutline: true,
      }
    );

    const cameras = await QrScanner.listCameras(true);
    let currentCamera = cameras.findIndex(c =>
      c.label.toLowerCase().includes('back')
    );
    if (currentCamera < 0) currentCamera = 0;

    if (cameras.length > 0) {
      scanner.setCamera(cameras[currentCamera].id);
      scanner.start();
      if (cameras.length > 1) {
        $('#change').show(300);
      }
    } else {
      p('No cameras found.');
    }

    let last: string | null = null;
    let timeout: number | null = null;
    function onScan(result: QrScanner.ScanResult) {
      const content = result.data;
      if (last !== content) {
        last = content;
        onNewData(content);
      }
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => { last = null; }, 1000);
    }

    function onNewData(content: string) {
      p(content);
      const arrived_at = $('#group_report_arrived_at').myGetNumValue();
      if (content.startsWith('GR')) {
        const base_url = '/group_reports/' + content.replace('GR', '');
        if (!arrived_at) {
          window.open(base_url, '_blank');
        } else {
          loader(true);
          const data: any = {
            group_report: {}
          };
          if (arrived_at == 1 || arrived_at == 2 || arrived_at == 3) {
            data.group_report.arrived_at = moment().format();
          }
          if (arrived_at == 3 || arrived_at == 4) {
            data.group_report.processed_at = moment().format();
          }
          $.ajax({
            url: base_url + '.json',
            type: 'PUT',
            data: data
          }).always(function (result) {
            p(result);
            loader(false);
            if (arrived_at == 2) {
              window.open(base_url, '_blank');
            } else {
              if (result.status == 404) {
                alert('Az adatlap nem található a rendszerben mert időközben törölve lett.');
              }
            }
          });
        }
      }
      if (content.startsWith('MR')) {
        window.open('/mission_reports/' + content.replace('MR', ''), '_blank');
      }
      if (content.startsWith('CT')) {
        window.open('/contracts/' + content.replace(/CTC|CTA|CTJ|CTI|CTS|CTM/, ''), '_blank');
      }
      if (content.startsWith('TRN')) {
        window.open('/trainings/' + content.replace('TRN', '') + '/attendance', '_blank');
      }
      ($('#beep')[0] as HTMLAudioElement).play();
    };

    $('#change').on('click', async function () {
      $('#change').blur();
      if (cameras.length <= 1) return;

      try {
        currentCamera = (currentCamera + 1) % cameras.length;
        await scanner.setCamera(cameras[currentCamera].id);
        p('Switched camera to: ' + cameras[currentCamera].label);
        // Optional: auto-mirror front cameras
        const label = cameras[currentCamera].label.toLowerCase();
        mirrored = label.includes('front');
        refreshMirror();
      } catch (e) {
        console.error(e);
        alert('Failed to switch camera.');
      }
    });

    const user_id = el.dataset.userid!;
    const connection = createConsumer().subscriptions.create(
      { channel: 'AndroidChannel', id: user_id },
      {
        connected: function () {
          p('connected');
          connection.send({
            action: 'qr',
            discovery_question: true
          });
          //this.perform('really_subscribed');
        },
        disconnected: function () {
          p('disconnected');
        },
        received: (data: any) => {
          p(data);
          switch (data.action) {
            case 'qr':
              if (data.msg.discovery_answer) {
                scanner.stop();
                $('.qr').hide();
                $('#remote').show();
              }
              if (data.msg.data) {
                onNewData(data.msg.data);
              }
              break;
          }
        }
      }
    );
  }
}